// Утилиты для мобильных устройств

/**
 * Определяет, является ли устройство мобильным
 */
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  return window.innerWidth <= 768 || 
         /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

/**
 * Возвращает CSS класс с анимацией только для десктопа
 */
export const animateOnlyDesktop = (animationClass: string): string => {
  return isMobileDevice() ? '' : animationClass;
};

/**
 * Возвращает объект стиля с анимацией только для десктопа
 */
export const animationStyleDesktopOnly = (styles: React.CSSProperties): React.CSSProperties => {
  if (isMobileDevice()) {
    return {
      ...styles,
      animation: 'none',
      transition: 'none',
      transform: 'none'
    };
  }
  return styles;
};

/**
 * Отключает анимации в зависимости от устройства
 */
export const maybeDisableAnimations = () => {
  if (isMobileDevice()) {
    // Добавляем стили для отключения анимаций
    const style = document.createElement('style');
    style.textContent = `
      * {
        animation-duration: 0s !important;
        animation-delay: 0s !important;
        transition-duration: 0s !important;
        transition-delay: 0s !important;
      }
    `;
    document.head.appendChild(style);
    
    // Отключаем Framer Motion анимации глобально
    if (typeof window !== 'undefined') {
      // Отключаем prefers-reduced-motion для принудительного отключения
      window.matchMedia = window.matchMedia || (() => ({ matches: true, addListener: () => {}, removeListener: () => {} }));
    }
  }
};

/**
 * Возвращает конфигурацию Framer Motion без анимаций для мобильных
 */
export const getMotionConfig = (config: any) => {
  if (isMobileDevice()) {
    return {
      ...config,
      initial: false,
      animate: {},
      exit: {},
      transition: { duration: 0 },
      whileHover: {},
      whileTap: {}
    };
  }
  return config;
};